export const matchOperation = {
  CONTAINS: 'contains',
  WORD: 'word',
};

export interface StringMatchRule {
  operation: 'contains' | 'word',
  needle: string,
}

type MatchOperation = 'contains' | 'word';

type ReplaceFn = (needle: string) => string;

function replaceContains(needle: string, haystack: string, doReplace: ReplaceFn): string {
  return haystack
    .toLowerCase()
    .replace(needle.toLowerCase(), doReplace(needle));
}

function replaceWord(word: string, haystack: string, doReplace: ReplaceFn): string {
  const words = haystack.split(' ');
  return words
    .map((w) => {
      // Remove commas, hashtags, exclamation points, etc.
      const plainWord = w.replace(/[^a-z0-9]/gi, '');
      if (word === plainWord.toLowerCase()) {
        return w.replace(plainWord, doReplace(plainWord));
      }
      return w;
    })
    .join(' ');
}

export function replace(
  needle: string,
  haystack: string,
  operation: MatchOperation,
  doReplace: ReplaceFn,
): string {
  switch (operation) {
    case 'contains':
      return replaceContains(needle, haystack, doReplace);
    case 'word':
      return replaceWord(needle, haystack, doReplace);
    default:
      return '';
  }
}

export function replaceAll(
  rules: StringMatchRule[],
  haystack: string,
  doReplace: ReplaceFn,
): string {
  let replaced = haystack;
  for (let i = 0; i < rules.length; i += 1) {
    replaced = replace(rules[i].needle, replaced, rules[i].operation, doReplace);
  }
  return replaced;
}
